import axios from 'axios';
import md5 from 'md5';
import {showToast} from "vant";


const BASE_URL = process.env.VUE_APP_BASE_URL;

console.log('当前请求地址前缀:', BASE_URL);


export const serviceForm = axios.create({
    baseURL: BASE_URL,  // 统一接口前缀
    timeout: 10000, // 超时时间
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});
// 响应拦截器（处理错误）
serviceForm.interceptors.response.use(
    response => {
        console.log(response.data);
        if(response.data.code != 200) {
            showToast(response.data.message);
        }
        return response.data;
    },
    error => Promise.reject(error)
);

export const service = axios.create({
    baseURL: BASE_URL,  // 统一接口前缀
    timeout: 10000, // 超时时间
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});
// 请求拦截器（添加Token等）
service.interceptors.request.use(config  => {
    const timestamp = Math.floor(Date.now() / 1000); // 当前时间戳（秒）
    const random4 = Math.floor(1000 + Math.random() * 9000); // 四位随机数 1000-9999

    let param = config.data.param;

    // 构造签名原文
    const signString = param + random4 + timestamp + localStorage.getItem('appsecret');
    const signStr = md5(signString);
    config.headers.timestamp  = timestamp;
    config.headers.random  = random4;
    config.headers.sign  = signStr;
    config.headers.appid  = localStorage.getItem('appid');
    console.log("appid+req:"+ config.headers.appid);
    config.headers.channeluserid  = localStorage.getItem('channel_userid');
    return config;
});
// 响应拦截器（处理错误）
service.interceptors.response.use(
    response => {
        console.log(response.data);
        if(response.data.code != 200) {
            showToast(response.data.message);
        }
        return response.data;
    },
    error => Promise.reject(error)
);



export const serviceUpload = axios.create({
    baseURL: BASE_URL,
    timeout: 10000,
    // 不设置 Content-Type
});

serviceUpload.interceptors.response.use(
    response => {
        if (response.data.code != 200) {
            showToast(response.data.message);
        }
        return response.data;
    },
    error => {
        showToast('请求失败：' + (error.response?.data?.message || error.message));
        return Promise.reject(error);
    }
);
